const REPORT_SERIES_COLORS = Object.freeze({
  total: '#201f4d',
  certificates: '#5b57dc',
  signatures: '#237f65',
  archive: '#b86616',
  'certificates-with-auth': '#4f46c8',
  'qualified-signatures': '#13735b',
  'simple-signatures': '#36a27f',
  other: '#71809d'
});

function productSectionColor(section) {
  return REPORT_SERIES_COLORS[section] || REPORT_SERIES_COLORS.total;
}

export { productSectionColor, REPORT_SERIES_COLORS };
